import { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { Row, Col, Typography, Button, Input, Form, message } from 'antd';
import { useHistory } from 'react-router-dom';
import AccountDeletionLayout from './AccountDeletionLayout';
import { useAuthContext } from '../../shared/context/auth-context';
import DeleteCompletionAlert from '../../components/Alert/DeleteCompletionAlert';
import useHttpClient from '../../shared/sendRequest/useHttpClient';
import EndPoints from '../../shared/endPoints/EndPoints.json';
import { button, cancelButton, disabledButton } from './style';
import LoadingSpin from '../../components/LoadingSpin/LoadingSpin';

const DeleteConfirmation = () => {
  const { ContractId, logout } = useAuthContext();
  const { sendRequest } = useHttpClient();
  const history = useHistory();
  const [email, setEmail] = useState('');

  const { data: contractInfo } = useQuery('getContractInfo', async () =>
    sendRequest({
      endpoint: `${
        EndPoints.BASEURL + EndPoints.CONTRACT.CONTRACT
      }/${ContractId}`,
      method: 'GET'
    })
  );
  const { mutate, isLoading } = useMutation(sendRequest, {
    onSuccess: data => {
      if (data) {
        message.success(<DeleteCompletionAlert />, 4);
        logout();
      }
    }
  });

  const onFinish = values => {
    if (values.email === contractInfo?.email) {
      mutate({
        endpoint: `${
          EndPoints.BASEURL + EndPoints.CONTRACT.CONTRACT
        }?ContractId=${ContractId}&RequestReason=${values.reason}`,
        method: 'DELETE'
      });
    } else {
      message.error(
        'Το συγκεκριμένο e-mail δεν αντιστοιχεί στο συμβόλαιο σου.'
      );
    }
  };

  if (isLoading) return <LoadingSpin />;
  return (
    <AccountDeletionLayout>
      <Form onFinish={onFinish}>
        <Row>
          <Typography.Text>
            Παρακαλούμε συμπλήρωσε το e-mail σου για την
          </Typography.Text>
        </Row>
        <Row>
          <Typography.Text>ταυτοποίηση σου. </Typography.Text>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item name="email">
              <Input
                onChange={e => {
                  setEmail(e.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Typography.Text>
            Πες μας αν θες το λόγο που ζήτησες τη
          </Typography.Text>
        </Row>
        <Row>
          <Typography.Text>
            &quot;Διαγραφή λογαριασμού&quot; σου:
          </Typography.Text>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item name="reason">
              <Input.TextArea rows={5} maxLength={160} showCount />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Typography.Text>
            Προσοχή! Μόλις ολοκληρωθεί η διαγραφή
          </Typography.Text>
        </Row>
        <Row>
          <Typography.Text>
            λογαριασμού, θα πρέπει στη συνέχεια να
          </Typography.Text>
        </Row>
        <Row>
          <Typography.Text>προχωρήσεις σε</Typography.Text>
          <Typography.Text strong>
            &nbsp;uninstall (απεγκατάσταση)
          </Typography.Text>
        </Row>
        <Row>
          <Typography.Text>της εφαρμογής από το κινητό σου.</Typography.Text>
        </Row>
        <Row justify="center">
          <Button
            style={email ? button : disabledButton}
            htmlType="submit"
            disabled={!email}
          >
            Διαγραφή λογαριασμού
          </Button>
        </Row>
        <Row justify="center">
          <Button
            style={cancelButton}
            type="link"
            onClick={() => {
              history.push('/');
            }}
          >
            Άκυρο
          </Button>
        </Row>
      </Form>
    </AccountDeletionLayout>
  );
};
export default DeleteConfirmation;
